import { DownloadContext } from '../DownloadContext';
import { ChunkDownloader } from './ChunkDownloader';
import { Downloader } from './Downloader';
import { IDownloader } from './IDownloader';
import { StreamDownloader } from './StreamDownloader';

export interface DownloaderConstrutorArgs {
  contentLength?: number;
  downloadContext: DownloadContext;
  url: string;
}

export interface IDownloaderFactory {
  create(args: DownloaderConstrutorArgs): IDownloader;
}

export class DownloaderFactory implements IDownloaderFactory {
  create(args: DownloaderConstrutorArgs) {
    return new Downloader(args);
  }
}

export class StreamDownloaderFactory implements IDownloaderFactory {
  create(args: DownloaderConstrutorArgs) {
    return new StreamDownloader(args);
  }
}

export class ChunkDownloaderFactory implements IDownloaderFactory {
  constructor(readonly chunkSize: number) {}
  create(args: DownloaderConstrutorArgs) {
    return new ChunkDownloader({ ...args, chunkSize: this.chunkSize });
  }
}
